import React from "react";
import { CrossIcon, MinusIcon } from "../../../assets/icons";
import "./ImageModal.scss";

const ImageModal = ({ title, isVisible, hideTitle, onClose, children }) => {
  if (!isVisible) return null;

  return (
    <div className="image-modal-overlay" onClick={onClose}>
      <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
        <section className="image-modal-container">
          {!hideTitle && (
            <header className="modal-header">
              <div className="modal-header-content">
                <h1 className="modal-title">{title}</h1>
                <div className="modal-icons">
                  <div className="modal-icon" onClick={onClose}>
                    <MinusIcon />
                  </div>
                  <div className="modal-icon" onClick={onClose}>
                    <CrossIcon />
                  </div>
                </div>
              </div>
            </header>
          )}
          <div className="modal-body">{children}</div>
        </section>
      </div>
    </div>
  );
};

export default ImageModal;
